import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNegotiationsStore, type Negotiation } from "../../stores/negotiationsStore";
import CustomStepper from "../../components/CustomStepper/CustomStepper";
import "./Configuration.scss";

export const Configuration: React.FC = () => {
	const { negotiation_id } = useParams<{ negotiation_id?: string }>();
	const { fetchNegotiationById } = useNegotiationsStore();
	const [currentNegotiation, setCurrentNegotiation] = useState<Negotiation | null>(null);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const loadNegotiation = async () => {
			if (!negotiation_id) return;
			
			setLoading(true);
			
			try {
				const negotiation = await fetchNegotiationById(parseInt(negotiation_id));
				setCurrentNegotiation(negotiation);
			} catch (error) {
				console.error('Error loading negotiation:', error);
				setCurrentNegotiation(null);
			} finally {
				setLoading(false);
			}
		};

		loadNegotiation();
	}, [negotiation_id, fetchNegotiationById]);

	if (negotiation_id && loading) {
		return (
			<div className="homepage">
				<div className="flex items-center justify-center h-64">
					<div className="text-center">
						<i className="pi pi-spinner pi-spin text-2xl mb-2"></i>
						<p>Loading negotiation...</p>
					</div>
				</div>
			</div>
		);
	}

	if (negotiation_id && !currentNegotiation) {
		return (
			<div className="homepage">
				<div className="flex items-center justify-center h-64">
					<div className="text-center">
						<i className="pi pi-exclamation-triangle text-2xl mb-2 text-yellow-500"></i>
						<p>Negotiation not found</p>
					</div>
				</div>
			</div>
		);
	}

	return (
		<>
			<div className="homepage">
				<CustomStepper />
			</div>
		</>
	);
};

export default Configuration;
